module.exports = __webpack_public_path__ + "static/media/power-supply.b60fce9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/power-supply.svg
// module id = 292
// module chunks = 0